import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { CustomerDetailsService } from 'src/app/angularJS/services/customer-detail/customer-detail.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';

/**
* A Controller which is used across all sub states of customers
*/
export class CustomerPageController {
  public static $inject = [
    'customer',
    'ACTToolbarService',
    '$state',
    '$rootScope',
    'customerService',
    'UserMessages',
    'customerDetailService',
    '$translate',
    'breadcrumbService',
    'userService',
    '$location'
  ];

  public actions: Array<any>;
  public direction: string;
  private enhancedDetails: any;

  constructor(
    private customer: InterACT.Interfaces.Customers.Customer,
    private toolbarService: ACTToolbarService,
    private $state: ng.ui.IStateService,
    private $rootScope,
    private customerService: CustomerService,
    private UserMessages: UserMessagesService,
    private customerDetailService: CustomerDetailsService,
    private $translate: ng.translate.ITranslateService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private $location: ng.ILocationService
  ) {
    if (this.customer.id) {
      this.enhancedDetails = customerDetailService.getEnhancedCustomerData(customer);
    }

    this.activate();
  }

  /**
   * A method which is used to instantiate the controller
   */
  private activate() {

    this.getRoleBasedTabs();
    const fullName = this.enhancedDetails && this.enhancedDetails.fullName ? this.enhancedDetails.fullName : 'ANONYMOUS';

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'CUSTOMERS',
        sref: 'customers'
      }, {
        name: fullName,
        sref: 'customers',
        options: {
          reload: 'customer'
        }
      }
    ]);

    this.toolbarService.getToolbar('primary')
      .then((toolbar: any) => {
        toolbar.setTitle(fullName);
        toolbar.setTabs(this.getRoleBasedTabs(), this.$state.current.data.selectedTab);
      });
  }

  private getRoleBasedTabs() {
    const custPerms = [];
    const tabOrder: string[] = ['customerTabsDetails', 'customerTabsSmartmediaList', 'customerTabsTickets', 'customerTabsEntitlements'];

    const cardNumber = this.$location.search().hasOwnProperty('cardNumber') ? this.$location.search()['cardNumber'] : undefined;

    const custTabPerms = Object.keys(this.userService.permissions)
      .filter((perm: string) => perm.toLowerCase().indexOf('customertabs') !== -1 && this.userService.permissions[perm].canRead);

    tabOrder.forEach((tabPermName: string) => {
      if (custTabPerms.indexOf(tabPermName) != -1) {
        const containsList: boolean = tabPermName.toLowerCase().indexOf('list') !== -1 ? true : false;
        const tabName: string = tabPermName.toLowerCase().replace(/customertabs|list/gi, '');

        if (tabName.toLowerCase() === 'details' && !this.customer.id) {
          return;
        }

        let sref = `customer.${tabName.toLowerCase()}${containsList ? '.list' : ''}`;

        if (cardNumber) {
          sref += `({ cardNumber: '${cardNumber}', customerId: '${this.customer.id ? this.customer.id : 'anonymous'}' })`;
        } else {
          sref += `({ customerId: '${this.customer.id ? this.customer.id : 'anonymous'}' })`;
        }

        custPerms.push({
          label: `CUSTOMER_TABS.${tabName.toUpperCase()}`,
          sref: sref
        });
      }
    });

    return custPerms;
  }
}
